<template>
    <v-card v-if="chain && chain.length" outlined class="mb-3">
        <v-card-title class="px-3 py-2">
            <v-icon left small color="primary">mdi-sitemap</v-icon>
            <span class="text-subtitle-2">Posizione nell'organigramma</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
            <div class="d-flex flex-wrap align-center" style="gap:6px">
                <template v-for="(d, i) in chain.slice().reverse()">
                    <v-chip :key="'d' + d.id" small label color="primary" outlined>
                        <v-icon left x-small>mdi-domain</v-icon>
                        {{ d.name }}
                    </v-chip>
                    <v-icon v-if="i < chain.length - 1" :key="'a' + i" small>mdi-chevron-right</v-icon>
                </template>
            </div>
            <div v-if="directManager" class="text-caption mt-2">
                <v-icon x-small>mdi-account-tie</v-icon>
                Manager diretto:
                <router-link :to="'/hremployees/' + directManager.id" class="text-decoration-none">
                    <strong>{{ directManager.name }}</strong>
                </router-link>
            </div>
            <div v-if="deptManagerName" class="text-caption">
                <v-icon x-small>mdi-account-supervisor</v-icon>
                Manager di reparto: <strong>{{ deptManagerName }}</strong>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'hr-employee-chain',
    props: { id: Number },

    data() {
        return {
            chain: [],
            directManager: null,
        }
    },

    computed: {
        deptManagerName() {
            if (!this.chain.length) return null
            // primo dipartimento (più vicino al dipendente) ha il suo manager
            return this.chain[0] && this.chain[0].manager_name ? this.chain[0].manager_name : null
        },
    },

    methods: {
        load() {
            if (!this.id) return
            this.axios.get(`hremployees/${this.id}/chain`).then(r => {
                this.chain = r.data.chain || []
                this.directManager = r.data.direct_manager || null
            })
        },
    },

    created() { this.load() },
    watch: { id() { this.load() } },
}
</script>
